export default __webpack_public_path__ + "static/media/logo-NIGMS.16e14c27.svg";